import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const Route = createFileRoute("/admin/servicios")({ component: AdminServicios });

function AdminServicios() {
  const [rows, setRows] = useState<any[]>([]);
  async function load() {
    const { data } = await supabase.from("services").select("*").order("sort_order");
    setRows(data ?? []);
  }
  useEffect(() => { load(); }, []);
  async function save(r: any) {
    const { error } = await supabase.from("services").update({ name: r.name, price: r.price, category: r.category, description: r.description, note: r.note, active: r.active, sort_order: r.sort_order }).eq("id", r.id);
    if (error) toast.error(error.message); else toast.success("Guardado");
  }
  return (
    <div>
      <h2 className="font-display text-xl font-semibold text-foreground">Servicios</h2>
      <div className="mt-4 overflow-x-auto rounded-md border border-hairline">
        <table className="w-full text-sm">
          <thead className="bg-surface text-left text-xs uppercase tracking-wider text-muted-foreground">
            <tr><th className="p-2">Nombre</th><th className="p-2">Categoría</th><th className="p-2">Precio</th><th className="p-2">Activo</th><th></th></tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.id} className="border-t border-hairline">
                <td className="p-2"><Input className="bg-surface-2 border-hairline" value={r.name} onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, name: e.target.value } : x))} /></td>
                <td className="p-2"><Input className="bg-surface-2 border-hairline" value={r.category} onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, category: e.target.value } : x))} /></td>
                <td className="p-2 w-28"><Input className="bg-surface-2 border-hairline" type="number" value={r.price} onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, price: Number(e.target.value) } : x))} /></td>
                <td className="p-2"><input type="checkbox" checked={r.active} onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, active: e.target.checked } : x))} /></td>
                <td className="p-2"><Button size="sm" onClick={() => save(r)} className="bg-primary text-primary-foreground hover:bg-primary/90">Guardar</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
